import { InjectionToken, Signal } from '@angular/core'
import { AppMode } from '@ftr/contracts/api/user'

export const APP_MODE = new InjectionToken<Signal<AppMode>>('APP_MODE')
